import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
/**
 * This component is temporarily necessary (until `react-router-dom`: v6+) to properly handle
 * ref forwarding. This requirement was introduced by MUI v4 but react-router-dom is slightly behind.
 * For now, all Links passed to a MUI component must use this AdapterLink component.
 */

var AdapterLink = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Link, Object.assign({
    innerRef: ref
  }, props));
});
export default AdapterLink;